// dilip 01/04/2022 2699714747 Added Mapped Records Table.
// sai krishna 01/12/2023 2699714747 added pagaination.
// Dilip 01/12/2023 2699714747 changed delete pop up message
// dilip 01/12/2023 2699714747 Added Sub Record Type column.
// Lalitha 01/17/2023 2699714747 changed delete pop up heading
// Sohel 01/18/2023 2699714747 changed delete pop up heading
// Ravi 01/31/2023 2699714747 fixed unsaved popup issue
// Sohel 02/06/2023 2698964415 Fixed page break issue
// suresh peddavoora 02/24/2023 2699714747 New UI changes
// Sohel 03/13/2023 2698964415 Import Manager Added Default Error Button
// Akhila 05/31/2023 2698964415 unsaved changes bug fixed
// Ravi 05/31/2023 2698964415  changed delete popup message
// Akhila 06/12/2023 2698964415 added role access
// Gireesh 12/12/2023 2698964415 updated table columns
import React, {useRef, useState} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
export default function MappedRecordTable({
  setRecords,
  records,
  isMultiRecordFormat,
  showSubRecordType,
  handleDirty,
  defaultError,
  setDefaultError = () => {},
  editExisting,
  DataManagerAccess,
}) {
  const [isDelete, setIsDelete] = useState(false);
  const deleteDataRef = useRef();
  const [rows, setRows] = useState(defaultRows);
  const columns = [
    {
      title: 'Record Name',
      field: 'recordCode',
      render: (rowData) => rowData?.recordCode?.replace(/ /g, '\u00a0')
    },
    {
      title: 'Record Description',
      field: 'recordDescription',
      render: (rowData) =>rowData?.recordDescription?.replace(/ /g, '\u00a0')
        
      
    },
    {
      title: 'Record Type',
      field: 'recordType',
      hidden: showSubRecordType && !defaultError,
    },
    {
      title: 'Sub Record Type',
      field: 'subRecordType',
      hidden: !showSubRecordType || !defaultError,
    },
  ];
  const recordGroupColumns = [
    {
      title: 'Record Group Name',
      field: 'recordCode',
    },
    {
      title: 'Record Group Description',
      field: 'recordDescription',
    },
    {
      title: 'Record Group Type',
      field: 'recordType',
    },
  ];

  const handleDeleteClose = () => {
    setIsDelete(false);
    deleteDataRef.current = null;
  };
  const handleSubmit = () => {
    const arr = [...records];
    const newData = arr.filter((row) => row.recordCode !== deleteDataRef.current?.recordCode);
    setRecords(newData);
    handleDeleteClose();
    handleDirty && handleDirty(true);
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title={!isMultiRecordFormat ? 'Delete Record' : 'Delete Record Group'}
        value={`Are you sure you want to delete the ${deleteDataRef.current?.recordCode || ''} ${
          !isMultiRecordFormat ? 'Record' : 'Record Group'
        } ?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={!isMultiRecordFormat ? columns : recordGroupColumns}
            icons={tableIcons}
            data={records?.length > 0 ? records.map((item) => ({...item})) : []}
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon />,
                  tooltip: 'Delete',
                  disabled: editExisting && !DataManagerAccess?.edit,
                  onClick: (event, rowData) => {
                    deleteDataRef.current = rowData;
                    setIsDelete(true);
                    setDefaultError(false);
                  },
                };
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
